export function setEquals<T>(set1: Set<T>, set2: Set<T>): boolean {
  if (set1.size !== set2.size) {
    return false;
  }

  if ([...set1].some(e => !set2.has(e))) {
    return false;
  }

  return true;
}
